import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { ApiBaseUrlContext } from '../App';

const Section4 = () => {
  const apiBaseUrl = useContext(ApiBaseUrlContext);  
  const { t } = useTranslation();
  const [notifications, setNotifications] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideInterval = 30000; // 30 seconds for each slide

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/mnt/api/notificationinput`); // await the API call
        setNotifications(response.data); // set the fetched data
      } catch (error) {
        console.error('Error fetching notifications:', error);
        setNotifications([]); // Ensure notifications is an array even if there's an error
      }
    };

    fetchNotifications();
  }, [apiBaseUrl]);

  useEffect(() => {
    if (notifications.length > 0) { // Ensure notifications are available before setting the interval
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % notifications.length);
      }, slideInterval);

      return () => clearInterval(interval);
    }
  }, [notifications, slideInterval]);

  return (

    <div className="db-box db-box_order-4">
      <div className="db-box__title-row">				
        <div className="db-box__title">{t('Section4.TodaysInformation')}</div>
      </div>

      {notifications.length > 0 ? (
        <div>
          <div className="db-box__news-title">{notifications[currentSlide]?.header}</div>
          <div className="db-box__news-desc">{notifications[currentSlide]?.text}</div>
        </div>
      ) : (
        <div className="db-box__news-desc">{t('Section4.NoNotifications')}</div>
      )}

    </div>

  );
};

export default Section4;
